var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"state-list-display-component"},[_c('div',{class:_vm.className,on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('div',[(_vm.showHoverbox)?_c('state-list-hover-box',{attrs:{"stateAbbreviations":_vm.stateAbbreviations}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }